import { getAuthHeader } from '../tokenStorage';
import { axiosInstance, noCacheHeaders } from './axiosInstance';

export const applyToFacilitate = async ({ programCode, data }) => {
  return axiosInstance.put(`/blapi/facilitatorApplication/applyToFacilitate/${programCode}`,
    data,
    {
      headers: getAuthHeader()
    }
  );
};

export const getLatestApplicationEmployer = async () => {
  return axiosInstance.get(
    `/blapi/facilitatorApplication/getLatestApplicationEmployer`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
};

export const getCorporatePartnersList = async () => {
  return axiosInstance.get(
    `/blapi/facilitatorApplication/getCorporatePartnersList`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
};
